import { render, staticRenderFns } from "./orderListGoods.vue?vue&type=template&id=4a49da79&scoped=true&"
import script from "./orderListGoods.vue?vue&type=script&lang=js&"
export * from "./orderListGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49da79",
  null
  
)

export default component.exports